import { Buttons } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const CheckoutButton = styled(Buttons.Classic)`
  width: 100%;
`;
